import Flex from '@deprecated-ui/common/Flex';
import Text from '@deprecated-ui/common/Text';
import NotationListItem from './NotationListItem';
import { NotationList, Container } from './styled';

interface ContentProps {
  notation: Array<any>;
  symbol: string;
  name: string;
  notationTag?: any;
  [key: string]: any;
}

function Content({
  notation,
  symbol,
  name,
  notationTag,
  ...props
}: ContentProps) {
  return (
    <Container direction="column" align="center" {...props}>
      <Flex justify="center" align="center" width="100%">
        <Text as="h1" size="20px" height="24px" align="center" family="bold">
          {symbol}
        </Text>
        {notationTag}
      </Flex>
      <Flex justify="center" align="center" width="100%">
        <Text as="p">{name}</Text>
      </Flex>
      {/* @ts-expect-error */}
      <Flex justify="center" align="center" py="14px">
        <Text as="p" align="center">
          Perusahaan memiliki Notasi Khusus sebagai berikut:
        </Text>
      </Flex>
      {/* @ts-ignore */}
      <NotationList direction="column" align="center" justify="space-evenly">
        <div>
          {notation.map(
            ({ notation_code, notation_desc, code, desc }) =>
              (code && desc) || (notation_code && notation_desc) ? (
                <NotationListItem
                  code={notation_code || code}
                  desc={notation_desc || desc}
                  key={`notation-${code}`}
                />
              ) : null,
            // eslint-disable-next-line function-paren-newline
          )}
        </div>
      </NotationList>
    </Container>
  );
}

export default Content;
